<template>
    <v-app>
        <app-navigation></app-navigation>

        <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
        </transition>

        <v-footer fixed height="auto" color="dark darken-1">
            <v-card class="flex" flat tile>
                <v-card-title class="grey darken-1" py-2>
                    <a class="none" :href="phone"><v-icon small color="white">fas fa-phone</v-icon> &nbsp {{ this.$myApp.customer.phone }}</a>
                    <v-spacer></v-spacer>
                    <a class="none" :href="email"><v-icon small color="white">fas fa-envelope</v-icon> &nbsp {{ this.$myApp.customer.email }}</a>
                </v-card-title>

                <v-card-actions class="blue lighten-5 justify-center py-1" >
                    Website by <sup>&copy</sup>{{this.$myApp.developer.company}} {{ new Date().getFullYear() }} <span v-if="this.$myApp.devMode">DEVELOPER</span>
                </v-card-actions>
            </v-card>

        </v-footer>


    </v-app>

</template>

<script>
import AppNavigation from '@/components/AppNavigation';

export default {
    name: 'App',
    components: {
        AppNavigation
    },
    data() {
        return {
            phone:'tel:'+this.$myApp.customer.phone,
            email:'mailto:'+this.$myApp.customer.email
        }
    },
    head: {
        title: function () {return {inner: this.$myApp.title,separator: ' '}},
        meta: function () {return[
            { name: 'application-name', content: this.$myApp.title },
            { name: 'description', content: this.$myApp.description },
            { name: 'author', content: this.$myApp.developer.name+' @ '+this.$myApp.developer.company },
            { p: 'og:title', c: this.$myApp.title},
            { p: 'og:description', c: this.$myApp.description},
            { p: 'og:type', c: 'article'},
            { p: 'og:image', c: this.$myApp.rootURL+'/images/app-icons/apple-icon.png'},
            { p: 'og:url', c: this.$myApp.rootURL},
            { p: 'og:site_name', c: this.$myApp.title}
            //{ property: 'fb:app_id', content: '123456789' }// Facebook
        ]},
        link: function () {return[
            {rel: 'canonical', href: this.$myApp.rootURL}
        ]}
        //script: [],
        //style: [],
    }
};

</script>

<style>
    .h100{height: calc(100vh - 64px )!important;  min-height:500px;}
    .h100foot{height: calc(100vh - 64px - 82px);  min-height:500px;}
    a.none {text-decoration: none;color:white !important;}
</style>
